export default {
  namespaced: true,
  state: {
    hospChoice: {},
    departChoice: {},
    appointInfo: {},
    appointUser: {},
    isFromAppoint: false
  },
  getters: {
    getHospChoice: state => {
      return state.hospChoice
    },
    getDepartChoice: state => {
      return state.departChoice
    },
    getAppointInfo: state => {
      return state.appointInfo
    },
    getAppointUser: state => {
      return state.appointUser
    }
  },
  mutations: {
    setHospChoice (state, hospChoice) {
      state.hospChoice = hospChoice
    },
    setDepartChoice (state, departChoice) {
      state.departChoice = departChoice
    },
    setAppointInfo (state, appointInfo) {
      state.appointInfo = appointInfo
    },
    setAppointUser (state, appointUser) {
      state.appointUser = appointUser
    },
    setIsFromAppoint(state, isFromAppoint){
      state.isFromAppoint = isFromAppoint
    }
  },
  actions: {
    initialUserInfo ({commit}) {
      // todo
      // commit('setUserInfo',window.getUserInfo ? window.getUserInfo() : {})
      commit('setUserInfo', {})
    }
  }
}
